import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useTrip(id) {
  const queryKey = ['trips', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { identifier: id } },
        {
          $project: {
            _id: false,
            identifier: true,
            driver: { code: true },
            vehicle: { identificationNumber: true },
            rfidCard: true,
            startTime: true,
            endTime: true,
            durationSeconds: {
              $round: [{ $divide: ['$durationSeconds', 86400] }, 8],
            },
            distanceMiles: {
              $round: [{ $multiply: ['$distanceKilometres', 0.62137119] }, 2],
            },
            maxSpeedMilesPerHour: {
              $round: [
                { $multiply: ['$maxSpeedKilometresPerHour', 0.62137119] },
                2,
              ],
            },
            startLocations: true,
            endLocations: true,
            classification: true,
            occupants: true,
          },
        },
      ];

      const trips = await api.post('pipeline/trips', { json, signal }).json();

      log('Read', 'Trips', { id });

      return trips[0] ?? null;
    },
    staleTime: 1000 * 60 * 60,
    enabled: !!id,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
